import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
} from '@angular/core';

@Directive({
  selector: '[formFieldClickable]',
  standalone: true,
})
export class FormFieldClickableDirective implements AfterViewInit {
  @Input() inputElement: HTMLElement | null = null;
  private hiddenFileInput: HTMLInputElement | null = null;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.hiddenFileInput = this.findHiddenFileInput();
    });
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (target.closest('button, input')) return;

    (this.inputElement ?? this.hiddenFileInput ?? this.findHiddenFileInput())?.click();
  }

  private findHiddenFileInput(): HTMLInputElement | null {
    const root = this.elementRef.nativeElement as HTMLElement;

    const directInput = root.querySelector('input[type="file"]');
    if (directInput) return directInput as HTMLInputElement;

    const ngxInputs = root.querySelectorAll('ngx-mat-file-input');
    for (const ngx of Array.from(ngxInputs)) {
      const fileInput = ngx.querySelector('input[type="file"]') ??
        Array.from(ngx.querySelectorAll('input')).find(
          input =>
            input.type === 'file' ||
            input.classList.contains('ngx-mat-file-input-element')
        );
      if (fileInput) return fileInput as HTMLInputElement;
    }

    return null;
  }
}
